import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Otolaryngology = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.395 16.535c0 .5-.4.901-.902.901-.5 0-.901-.4-.901-.901a6.5 6.5 0 0 0-6.512-6.512 6.5 6.5 0 0 0-6.512 6.512v2.905c3.205.401 5.81 3.206 5.81 6.612a6.713 6.713 0 0 1-6.712 6.713c-.501 0-.902-.4-.902-.902 0-.5.4-.901.902-.901 2.705 0 4.809-2.204 4.809-4.81a4.751 4.751 0 0 0-3.908-4.708v2.605c0 .5-.4.902-.901.902s-.902-.401-.902-.902v-7.414c0-4.609 3.807-8.416 8.416-8.416 4.608 0 8.215 3.707 8.215 8.316Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05 16.034c0-9.017 7.313-16.23 16.43-16.03 8.015.2 14.828 6.713 15.429 14.728.4 5.81-2.204 11.02-6.512 14.126-2.505 1.803-4.208 4.308-4.809 7.213 0 .1 0 .2-.1.3 0 .1 0 .201-.1.201-.902 3.607-3.908 6.512-7.615 7.213-6.11 1.303-11.621-3.506-11.621-9.517 0-.501.4-.902.902-.902.5 0 .901.4.901.902 0 4.909 4.509 8.816 9.618 7.814a7.86 7.86 0 0 0 6.111-5.91c0-.1 0-.201.1-.201 0-.1 0-.2.1-.2.702-3.407 2.706-6.312 5.511-8.316 3.807-2.805 6.111-7.414 5.81-12.523-.7-7.113-6.712-12.924-13.825-13.125-8.015-.2-14.527 6.212-14.527 14.227 0 .5-.4.902-.902.902-.5 0-.901-.401-.901-.902Z"
  }));
});
Otolaryngology.displayName = 'Otolaryngology';
Otolaryngology.defaultProps = {
  'aria-label': 'Otolaryngology'
};
export default Otolaryngology;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Otolaryngology.js
// module id = 3682
// module chunks = 11